import React from 'react'
import classes from './SearchInput.module.css'

const SearchInput = ({className,...rest}) => {
  return (
    <input className={`${classes.input} ${className}`} {...rest}/>
  )
}

export default SearchInput
